import api from "./axiosInstance";

/**
 * @param {number} limit
 * @param {number} offset
 */
export const getAffiliates = async (limit = 10, offset = 0) => {
  const response = await api.get(
    `api/v1/affiliate-links/?limit=${limit}&offset=${offset}`
  );
  return response.data;
};

export const getAffiliatesByEventId = async (limit = 10, offset = 0, eventId) => {
  const res = await api.get(`api/v1/affiliate-links/?event=${eventId}&limit=${limit}&offset=${offset}`);
  return res.data;
};

export const createAffiliate = async (payload) => {
  const response = await api.post(
    "api/v1/affiliate-links/",
    payload
  );
  return response.data;
};

export const updateAffiliate = async (affiliateId, payload) => {
  const response = await api.patch(
    `api/v1/affiliate-links/${affiliateId}/`,
    payload
  );
  return response.data;
};


export const deleteAffiliate = async (affiliateId) => {
  await api.delete(`api/v1/affiliate-links/${affiliateId}/`);
};

